import { Component, registerComponent } from 'js/component.js';

const LINK_PREFIX = '#modal-';

class SecurityModalContainer extends Component {
    /** @param {HTMLDialogElement} modalEl */
    openModal = (modalEl) => {
        if (modalEl) {
            modalEl.showModal();
            document.body.classList.add('no-scroll');
            if (modalEl.querySelector('.ra__player')) {
                window.dispatchEvent(new Event('resize'));
            }
        }
    };

    handleModalClose = () => {
        window.dispatchEvent(new CustomEvent('pauseVideo'));
        if (window.vidyardEmbed) {
            const { players } = window.VidyardV4;
            players[0].pause();
        }
        document.body.classList.remove('no-scroll');
    };

    /**
     * @param {MouseEvent} ev
     */
    handleModalLinkClick = (ev) => {
        ev.preventDefault();
        const modalEl = this.element.querySelector(`dialog${ev.currentTarget.getAttribute('href')}`);
        this.openModal(modalEl);
    };

    addEventListeners() {
        const linkEls = document.querySelectorAll(`[href^="${LINK_PREFIX}"]`);
        linkEls.forEach((linkEl) => {
            linkEl.addEventListener('click', this.handleModalLinkClick);
            linkEl.addEventListener('keydown', (ev) => {
                if (ev.key === 'Enter') {
                    this.handleModalLinkClick(ev);
                }
            });
        });

        const modalEls = document.querySelectorAll('dialog.security-modal-container__dialog');
        modalEls.forEach((modalEl) => {
            modalEl.addEventListener('close', this.handleModalClose);
            modalEl.querySelector('.security-modal-container__backdrop').addEventListener('click', () => modalEl.close());
            modalEl.querySelectorAll('a')
                .forEach((linkEl) => linkEl.addEventListener('click', () => modalEl.close()));
        });

        const selectAllCheckbox = this.element.querySelector('.security-modal-container__form-checkbox--select-all input[type="checkbox"]');
        const checkboxes = this.element.querySelectorAll('.security-modal-container__form-checkbox:not(.security-modal-container__form-checkbox--select-all) input[type="checkbox"]');
        const savePreferencesBtn = this.element.querySelector('.security-modal-container__form-button');

        selectAllCheckbox.addEventListener('change', () => {
            checkboxes.forEach((checkbox) => {
                checkbox.checked = selectAllCheckbox.checked;
            });
            const selectedCheckboxes = this.element.querySelectorAll('.security-modal-container__form-checkbox:not(.security-modal-container__form-checkbox--select-all) input[type="checkbox"]:checked');
            savePreferencesBtn.setAttribute('href', `${savePreferencesBtn.getAttribute('data-href-root')}${[...selectedCheckboxes].map((checkbox) => checkbox.name).join(',')}`);
        });
        checkboxes.forEach((checkbox) => {
            checkbox.addEventListener('change', () => {
                const selectedCheckboxes = this.element.querySelectorAll('.security-modal-container__form-checkbox:not(.security-modal-container__form-checkbox--select-all) input[type="checkbox"]:checked');
                savePreferencesBtn.setAttribute('href', `${savePreferencesBtn.getAttribute('data-href-root')}${[...selectedCheckboxes].map((checkbox) => checkbox.name).join(',')}`);
            });
        });
    }

    init() {
        this.addEventListeners();
    }
}

registerComponent('.security-modal-container', SecurityModalContainer);